import React from 'react';

// Red/black suit meta — true playing-card convention: Hearts/Diamonds red, Spades/Clubs black
export const SpadeSuit = ({ size = 20, className = '' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor">
    <path d="M12 2.2c-.6 0-1.1.3-1.4.8L5.2 11c-1.6 2.1-1 5.2 1.4 6.5 1.6.9 3.6.6 4.9-.7l-.6 2.4c-.2.7.3 1.4 1 1.6h2.2c.7-.2 1.2-.9 1-1.6l-.6-2.4c1.3 1.3 3.3 1.6 4.9.7 2.4-1.3 3-4.4 1.4-6.5L13.4 3c-.3-.5-.8-.8-1.4-.8z"/>
  </svg>
);
export const HeartSuit = ({ size = 20, className = '' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor">
    <path d="M12 21s-7.5-4.6-9.6-9.3C.6 7.6 3 3.7 7 3.7c2 0 3.7 1 5 2.6 1.3-1.6 3-2.6 5-2.6 4 0 6.4 3.9 4.6 8-2.1 4.7-9.6 9.3-9.6 9.3z"/>
  </svg>
);
export const DiamondSuit = ({ size = 20, className = '' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor">
    <path d="M12 2L21 12 12 22 3 12z"/>
  </svg>
);
export const ClubSuit = ({ size = 20, className = '' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor">
    <path d="M12 2.5c-2.6 0-4.7 2.1-4.7 4.7 0 .9.2 1.7.7 2.4-.6-.3-1.4-.5-2.1-.5-2.6 0-4.7 2.1-4.7 4.7s2.1 4.7 4.7 4.7c1.5 0 2.9-.7 3.7-1.9l-.9 3.9c-.2.7.4 1.3 1 1.3h4.6c.7 0 1.2-.6 1-1.3l-.9-3.9c.9 1.2 2.2 1.9 3.7 1.9 2.6 0 4.7-2.1 4.7-4.7s-2.1-4.7-4.7-4.7c-.7 0-1.5.2-2.1.5.4-.7.7-1.5.7-2.4 0-2.6-2.1-4.7-4.7-4.7z"/>
  </svg>
);

export function SuitFor({ name, size = 20, className = '' }) {
  if (name === 'spade') return <SpadeSuit size={size} className={className} />;
  if (name === 'heart') return <HeartSuit size={size} className={className} />;
  if (name === 'diamond') return <DiamondSuit size={size} className={className} />;
  if (name === 'club') return <ClubSuit size={size} className={className} />;
  return null;
}

// Troop → suit mapping (poker-club visual language)
//  Infantry = Spade (defensive wall, black)
//  Archers  = Club  (bow stem, black)
//  Cavalry  = Diamond (fast strike, red)
export const typeMeta = {
  infantry: { label: 'Infantry', suit: 'spade',   iconClass: 'bg-neutral-100 text-[#0d0d0d] dark:bg-[#1a3b2d] dark:text-[#f5e6b8]' },
  cavalry:  { label: 'Cavalry',  suit: 'diamond', iconClass: 'bg-red-50 text-[#c92a2a] dark:bg-[#2a1515] dark:text-[#ff6b6b]' },
  archers:  { label: 'Archers',  suit: 'club',    iconClass: 'bg-neutral-100 text-[#0d0d0d] dark:bg-[#1a3b2d] dark:text-[#f5e6b8]' },
};
